;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .controller('CardDetailModalController', CardDetailModalController)

  CardDetailModalController.$inject = [
    // Angular
    '$state',
    // Libs
    '$uibModalInstance',
    // Managers
    // Services
    'CardCreationService', 'UtilService',
    // Const
    // Resolved
    'concern', 'configuration', 'data'
  ]

  function CardDetailModalController (// Angular
    $state,
    // Libs
    $uibModalInstance,
    // Managers
    // Services
    CardCreationService, UtilService,
    // Const
    // Resolved
    concern, configuration, data) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        concern: concern,
        count: data.meta.total,
        data: data.data,
        // Public Methods
        close: close,
        editCard: editCard,
        ok: ok
      })

      init()
    }

    function init () {
      switch (concern) {
        case 'balance':
        case 'invoice':
        case 'deposit':
          _.each(self.data, function (invoice) {
            if (invoice.status === 'draft') {
              invoice.formatted = 'Brouillon'
            } else {
              invoice.formatted = UtilService.getInvoiceNumber(invoice, 'invoice')
            }


            /* if (!invoice.fullTotal || (invoice.fullTotal === 0 && invoice.total !== 0)) {
              var vats = _.reduce(invoice.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  var vat = line.VAT
                  var vatTotal = _.find(acc, {vat: vat})
                  if (!vatTotal) {
                    vatTotal = {vat: vat, amount: 0}
                    acc.push(vatTotal)
                  }
                  vatTotal.amount += line.discountedTotal * line.VAT / 100
                  return acc
                }, [])
              var total = _.reduce(invoice.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  return acc + line.discountedTotal
                }, 0)
              invoice.fullTotal = total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
            } */
          })
          break
        case 'quote':
          _.each(self.data, function (quote) {
            if (quote.status === 'draft') {
              quote.formatted = 'Brouillon'
            } else {
              quote.formatted = UtilService.getInvoiceNumber(quote, 'quote')
            }

            /* if (!quote.fullTotal || (quote.fullTotal === 0 && quote.total !== 0)) {
              var vats = _.reduce(quote.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  var vat = line.VAT
                  var vatTotal = _.find(acc, { vat: vat })
                  if (!vatTotal) {
                    vatTotal = { vat: vat, amount: 0 }
                    acc.push(vatTotal)
                  }
                  vatTotal.amount += line.discountedTotal * line.VAT / 100
                  return acc
                }, [])
              var total = _.reduce(quote.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  return acc + line.discountedTotal
                }, 0)
              quote.fullTotal = total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
            } */
          })
          break

        case 'creditnote':
          _.each(self.data, function (creditnote) {
            if (creditnote.status === 'draft') {
              creditnote.formatted = 'Brouillon'
            } else {
              creditnote.formatted = UtilService.getInvoiceNumber(creditnote, 'creditnote')
            }
          })
          break

        case 'product':
          break
      }
    }

    function editCard () {
      CardCreationService.configureCard(angular.copy(configuration)).then(function (card) {
        card.save().then(function () {
          $state.reload()
          $uibModalInstance.dismiss()
        })
      })
    }

    function close () {
      $uibModalInstance.dismiss()
    }

    function ok () {
      $uibModalInstance.close()
    }
  }
})(window.angular, window._)
